import { FolderZipOutlined } from "@mui/icons-material";
import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import CardFolder from "../../../../components/CardFolder ";
import FolderLoader from "../../FolderLoader";
import NoRecordsFound from "../../../../components/NoRecordsFound";
import UnauthorizedForGJ from "../../UnauthorizedForGJ";

const Folders = ({ rootPath }) => {
  const { data, isFetching, isSuccess, isError, GJError } = useOutletContext();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  if (!searchParams.has("is_posted")) {
    setSearchParams({ is_posted: "0", status: "pending" });
  }

  const navigateToFolderYear = (year) => {
    navigate({
      pathname: `/general-journal/${rootPath}/${year}`,
      search: searchParams.toString(),
    });
  };

  return (
    <>
      <Box width={1}>
        <Stack>
          <Divider sx={{ marginTop: 2 }} />
          <Stack direction="row" padding={2} height="6vh" alignItems="center" gap={1}>
            <FolderZipOutlined sx={{ opacity: 0.8 }} />
            <Typography fontWeight={500} sx={{ opacity: 0.8 }}>
              General Journal Folders
            </Typography>{" "}
          </Stack>
          <Divider />
        </Stack>
        <Stack width={1} direction="row" gap={2} padding={2} alignItems="center">
          {!isFetching &&
            isSuccess &&
            data?.map((accrualYear) => {
              return (
                <React.Fragment key={accrualYear}>
                  <CardFolder
                    value={accrualYear}
                    onClick={() => navigateToFolderYear(accrualYear)}
                  />
                </React.Fragment>
              );
            })}

          {isFetching && <FolderLoader />}
        </Stack>
        {((isSuccess && !Boolean(data?.length)) || isError) && GJError?.status !== 403 && (
          <Stack height={1} direction="row" justifyContent="center" alignItems="center">
            <NoRecordsFound />
          </Stack>
        )}

        {isError && GJError?.status === 403 && <UnauthorizedForGJ error={GJError?.data?.error} />}
      </Box>
    </>
  );
};

export default Folders;
